import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './../style.css' ;

export default class DashTotalResults extends Component {
    handleResetFilter = () => {
        this.props.ResetFilter();
    }
    handleDownloadInfo = () => {
        this.props.DownloadInfo();
    }
    handleSocketClick = () => {
        this.props.SocketClick();
    }
    getTitle = () => {
        const { timeResult } = this.props;
        let result = 0;
        try { timeResult[0].dataSet.map(val => result += val.value); } catch (e) { return "Total Resultados"}
        return 'Total Resultados: ' + result;
    }

    render() {
        return (
            <Grid className="optionsResult">
                <Grid className="Total" >
                  <span className="TotalResult">
                      {this.getTitle()}
                  </span>
                </Grid>
            </Grid>
        )
    }
}
